<template>
    <div class="m-news-item">
        <!--<a :href="`report.html?id=${news.id}`">-->
        <div class="div_img" style=""><img :src="news.pic" alt=""></div>
        <div class="div_mid">
            <h2>{{news.title}}</h2>
        </div>
        <div class="div_right">
            <span>{{news.date}}</span>
        </div>
        <!--</a>-->
    </div>
</template>

<script>
export default {
    name: 'NewsItem',
    props: ['news'],
    //methods: {},
    // data() {},
    // mounted() {},
};
</script>

<style lang="less">
.m-news-item {
    position: relative;
    width: 100%;
    background: #ffffff;
    margin-bottom: 0.599rem;
    box-shadow: 0 5px 8px 0 rgba(232, 232, 232, 0.5);
}
.div_img {
    height: 4.07rem;
    overflow: hidden;
    line-height: 4.07rem;
    vertical-align: center;
    img {
        width: 100%;
        line-height: 100%;
        // margin-top: -1rem;
    }
}
.div_mid {
    h2 {
        font-family: PingFangSC-Regular;
        padding-top: 8px;
        box-sizing: border-box;
        padding-left: 0.428rem;
        font-size: 0.5rem;
        color: #4a4a4a;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.div_right {
    font-family: PingFangSC-Regular;
    font-size: 0.357rem;
    color: #9b9b9b;
    text-align: left;
    padding-left: 0.458rem;
    padding-top: 4px;
    padding-bottom: 0.357rem;
}
</style>
